import { EventDispatcher, documentReady, gebcn, gebi, isMobileView, isValidEmail, l, lc, lerp, qs, qsa } from '@utils/toolbox';
import { ConnectApi } from '@js/plugins/connectApi';
import { SearchBox } from '@module/SearchBox/SearchBox';
import noUiSlider from '@js/plugins/nouislider';


const carbonCompensate = {
	init () {
		this.$dom = {
			homeIntro: gebi('home-intro-sections'),
			searchBox: gebi('abSearchBox'),
			decreasePassengers: gebi('decrease-passengers'),
			increasePassengers: gebi('increase-passengers'),
			passengersCount: gebi('passenger-count'),
			flightTypeCheckbox: gebi('flightType'),
			reduceSlider: gebi('slider-reduce'),
			reducePrice: gebi('reduce-price'),
			reduceText: gebi('reduce-text'),
			reduceLink: gebi('reduce-link'),
			reduceEmissions: gebi('reduce-emissions')
		};

		this.store = {
			co2: null,
			co2Price: null
		};

		this.initSearchBox();
		this.initSlider();
		this.bindEvents();
	},
	initSlider () {
		noUiSlider.create(this.$dom.reduceSlider,
			{
				pips: {
					mode: 'count',
					values: 3,
					density: 4
				},
				format: {
					to: v => v | 0,
					from: v => v | 0
				},
				step: 1,
				tooltips: [true],
				start: [js_params.climateCompensationBiofuelStartPercentage],
				connect: [true, false],
				range: {
					min: 0,
					max: 100
				}
			});
		// Add a percent sign to the tooltips
		this.$dom.reduceSlider.noUiSlider.on('update', (values, handle) => {
			this.$dom.reduceSlider.querySelector('.noUi-tooltip').innerHTML = `${values[handle]}%`;
			this.$dom.reduceText.innerHTML = l('searchBox.climateComp.reduce') + ' ' + values[handle] + '%';
			if (!this.store.co2) {
				return;
			}
			this.setBiofuelCost();
		});
	},

	setBiofuelCost () {
		const sliderPercentage = this.$dom.reduceSlider.noUiSlider.get() / 100;
		const price = lerp(0, this.store.co2 * js_params.climateCompensationBiofuelCostPerKg, sliderPercentage);
		const url = new URL(this.$dom.reduceLink.href);
		url.searchParams.set('value', price.toFixed());
		this.$dom.reduceLink.href = url.toString();
		this.$dom.reducePrice.innerHTML = lc(price);

		this.$dom.reduceEmissions.innerHTML = lerp(0, this.store.co2, sliderPercentage).toFixed().toLocaleString('sv') + ' kg CO₂';
	},

	initSearchBox () {
		window.searchBox = new SearchBox({
			id: 'abSearchBox',
			storeInLocalStorage: false,
			calendarRender: gebi('ab-dateselector-carbon'),
			config: { tripType: 2 },
			isCarbon: true
		});
		// the hidden date fields never get populated here but updateLegs still reads data-date
		qsa('.abSearchBox__depart', this.$dom.searchBox).forEach((field) => {
			field.dataset.date = js_params.isoDates.fromIndex;
		});
	},

	listItemClick (listItem) {
		if (!listItem?.dataset?.iata) {
			return;
		}
		const parent = listItem.closest('.another-emission-parent');
		const listItemParent = listItem.closest('.list-wrapper');
		const input = qs('input', parent);
		this.toggleInputFocus({ target: input }, false);
		input.value = '';
		input.dataset.iata = listItem.dataset.iata;
		qs('.SearchFieldMulti__checked_iatas_container', parent).innerHTML
			= `<div class="SearchFieldMulti__checked_iata"><span>${listItem.innerText.trim()}</span>`
			+ '<div class="SearchFieldMulti__checked_iata--clear"><i class="icon icon-cross"></i></div></div>';
		listItemParent.innerHTML = '';
		parent.classList.add('no-autocomplete');
		this.callEmissionCalc();
	},

	clearPickedValue (input) {
		input.removeAttribute('data-iata');
		qs('.SearchFieldMulti__checked_iatas_container', input.closest('.another-emission-parent')).innerHTML = '';
	},

	toggleInputFocus (event, isFocus) {
		const eventTarget = event.target.closest('.another-emission-parent');
		const className = 'another-emission-parent--active';
		const classNameParent = 'abSearchBox--show-overlay';
		const method = isFocus ? 'add' : 'remove';
		eventTarget.classList[method](className);
		eventTarget.classList[method]('SearchFieldMulti__modal--open');
		qs('.SearchFieldMulti__wrapper', eventTarget).classList[method]('SearchFieldMulti__wrapper--active');
		this.$dom.searchBox.classList[method](classNameParent);
		if (isFocus) {
			this.initialScrollPos = window.scrollY;
			const elemOffset = event.target.getBoundingClientRect().top + window.scrollY - 40;

			if (isMobileView()) {
				window.scrollTo({ top: elemOffset });
			}
		} else {
			window.scrollTo(this.initialScrollPos || 0, 0);
		}
	},

	bindEvents () {
		this.$dom.searchBox.addEventListener('keydown', (event) => {
			if (event.target.classList.contains('emission-airline-input') || event.target.classList.contains('emission-aircraft-input')) {
				switch (event.key) {
					case 'Backspace': {
						// a picked value is a single unit, clear all of it at once
						if (event.target.dataset.iata) {
							event.preventDefault();
							this.clearPickedValue(event.target);
							this.showSuggestions(event.target);
							this.callEmissionCalc();
						}
						break;
					}
					case 'Enter': {
						const listItem = event.target.closest('.another-emission-parent').querySelector('.SearchFieldMulti__row--hovered');
						this.listItemClick(listItem);
						event.preventDefault();
						EventDispatcher.dispatch('targetNextInput', event.target);
						break;
					}
					case 'ArrowUp':
					case 'ArrowDown': {
						const list = event.target.closest('.another-emission-parent').querySelector('.list-wrapper');
						const rows = qsa('.list-item', list);
						const hoverClass = 'SearchFieldMulti__row--hovered';
						let hoveredRow = list.querySelector(`.${hoverClass}`);

						if (!rows.length) {
							return;
						}

						if (!hoveredRow) {
							hoveredRow = rows[0];
							hoveredRow.classList.add(hoverClass);
							return;
						}

						const hoveredIndex = rows.indexOf(hoveredRow);

						// Determine target row index
						const newIndex = (event.key === 'ArrowUp') ? Math.max(0, hoveredIndex - 1) : Math.min(rows.length - 1, hoveredIndex + 1);

						// Update hovered row
						hoveredRow.classList.remove(hoverClass);
						rows[newIndex].classList.add(hoverClass);
						rows[newIndex].scrollIntoView({ block: 'nearest' });

						break;
					}
				}
			}
		});

		this.$dom.searchBox.addEventListener('focusout', (event) => {
			const eventTarget = event.target;
			// Aircraft / Airline
			if (eventTarget.classList.contains('emission-aircraft-input') || eventTarget.classList.contains('emission-airline-input')) {
				eventTarget.closest('.another-emission-parent').classList.add('no-autocomplete');
				const listElement = qs('.list-wrapper', event.target.closest('.another-emission-parent'));
				eventTarget.value = '';
				this.toggleInputFocus(event, false);
				listElement.innerHTML = '';
				this.callEmissionCalc();
			}
		});

		this.$dom.searchBox.addEventListener('focusin', (event) => {
			// Aircraft / Airline
			if (event.target.classList.contains('emission-input')) {
				this.toggleInputFocus(event, true);
				this.showSuggestions(event.target);
			}
		});

		this.$dom.searchBox.addEventListener('input', (event) => {
			const eventTarget = event.target;
			// Airline and aircraft inputs
			if (eventTarget.classList.contains('emission-aircraft-input') || eventTarget.classList.contains('emission-airline-input')) {
				// Controversial "feature": dirty field, reset value
				this.clearPickedValue(eventTarget);
				this.toggleInputFocus(event, true);
				this.showSuggestions(eventTarget);
			}
		});

		this.$dom.searchBox.addEventListener('mousedown', (event) => {
			const eventTarget = event.target;

			if (eventTarget.classList.contains('abSearchBox__overlay')) {
				this.$dom.searchBox.classList.remove('abSearchBox--show-overlay');
				qsa('.emission-input', this.$dom.searchBox).forEach(input => this.toggleInputFocus({ target: input }, false));
				this.callEmissionCalc();
			}

			// Decrease passengers
			if (eventTarget === this.$dom.decreasePassengers) {
				const numberOfPassengers = parseInt(this.$dom.passengersCount.innerText) - 1;
				if (numberOfPassengers > 0) {
					this.$dom.passengersCount.innerText = numberOfPassengers;
					this.callEmissionCalc();
				}
				if (numberOfPassengers < 2) {
					this.$dom.decreasePassengers.classList.add('abPassengers__btn--disabled');
				}
				return;
			}

			// Increase passengers
			if (eventTarget === this.$dom.increasePassengers) {
				const numberOfPassengers = parseInt(this.$dom.passengersCount.innerText) + 1;
				this.$dom.passengersCount.innerText = numberOfPassengers;
				this.$dom.decreasePassengers.classList.remove('abPassengers__btn--disabled');
				this.callEmissionCalc();
			}

			// Neither the x nor the list header may steal focus and close the list
			if (eventTarget.closest('.SearchFieldMulti__checked_iata--clear, .list-item-header')) {
				event.preventDefault();
				return;
			}

			// List item
			if (eventTarget.closest('.list-item')) {
				this.listItemClick(eventTarget.closest('.list-item'));
			}
		});

		this.$dom.searchBox.addEventListener('click', (event) => {
			// clearing on mousedown would hide the x mid-gesture and land the click on the field, focusing it
			if (event.target.closest('.SearchFieldMulti__checked_iata--clear')) {
				this.clearPickedValue(qs('input', event.target.closest('.another-emission-parent')));
				this.callEmissionCalc();
				return;
			}

			// Focus child input on parent click
			if (event.target.closest('.emission-relative-parent')) {
				const parent = event.target.closest('.emission-relative-parent');
				qs('input', parent)?.focus();
			}

			if (event.target.classList.contains('SearchFieldMulti__apply_btn')) {
				this.callEmissionCalc();
			}
		});

		this.$dom.flightTypeCheckbox.addEventListener('change', () => {
			this.callEmissionCalc();
		});

		EventDispatcher.addEventListener('searchBox:legAdded', () => {
			const airlineInputs = gebcn('emission-airline-input');
			this.clearPickedValue(airlineInputs[airlineInputs.length - 1]);
			airlineInputs[airlineInputs.length - 1].value = '';
			const aircraftInputs = gebcn('emission-aircraft-input');
			this.clearPickedValue(aircraftInputs[aircraftInputs.length - 1]);
			aircraftInputs[aircraftInputs.length - 1].value = '';
			this.fixInputTabIndexes();
		});

		watch(() => window.searchBox.data.legs, (newValue, oldValue) => {
			this.callEmissionCalc();
		}, { deep: true });

		// Event handlers on element only existing on Flygresor.se (Om oss section and newsletter)
		if (js_params.domain === 'flygresor.se') {
			const newsForm = gebi('news-letter-form');

			gebi('home-info-show-more-btn').addEventListener('click', (e) => {
				const hiddenSections = this.$dom.homeIntro.getElementsByClassName('home-intro__section--hidden');

				Array.prototype.forEach.call(hiddenSections, (section) => {
					section.classList.remove('home-intro__section--hidden');
				});

				e.target.parentNode.style.display = 'none';
			});


			// About handling events for the newsletter subscription
			newsForm.addEventListener('submit', (e) => {
				e.preventDefault();

				const emailField = e.target.querySelector('#email-field');
				const emailAddress = emailField.value;

				if (isValidEmail(emailAddress)) {
					ConnectApi('NewsletterSubscription', 'subscribe', [emailAddress]).then((response) => {
						window.trackEvent.triggerGAevent('newsletter', 'registration');
						newsForm.innerHTML = response;
					});
				} else {
					window.alert(l('pricewatcher.form.emailError'));
					e.target.querySelector('.input-field-section').classList.add('error');
					emailField.focus();
				}
			});
		}
	},
	showSuggestions (input) {
		const configs = {
			'emission-airline-input': {
				headerText: l('carbonCompensate.input.airline.header'),
				searchAircraftAirline: 'searchAirlines',
				connectApiResponseProperty: 'code',
				hasLogo: true
			},
			'emission-aircraft-input': {
				headerText: l('carbonCompensate.input.aircraft.header'),
				searchAircraftAirline: 'searchAircrafts',
				connectApiResponseProperty: 'iata'
			}
		};
		const config = configs[input.classList.contains('emission-aircraft-input') ? 'emission-aircraft-input' : 'emission-airline-input'];

		const searchTerm = input.value;
		const requestId = this.suggestionRequestId = (this.suggestionRequestId || 0) + 1;

		ConnectApi('EmissionCalc', config.searchAircraftAirline, [searchTerm]).then((response) => {
			// only the latest request may render, an earlier slower response would overwrite it,
			// and the input can also have lost focus entirely while the request was in flight
			if (requestId !== this.suggestionRequestId || document.activeElement !== input) {
				return;
			}
			input.closest('.another-emission-parent').classList.remove('no-autocomplete');
			const listElement = qs('.list-wrapper', input.closest('.another-emission-parent'));
			let listHtml = '';

			const generateText = item => item.name.includes(`(${item[config.connectApiResponseProperty]})`) ? item.name : `${item.name} (${item[config.connectApiResponseProperty]})`;
			// same match highlighting as the from/to dropdowns, only at the start of words
			const highlightMatch = (text) => {
				if (!searchTerm) {
					return text;
				}
				const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
				return text.replace(new RegExp(`\\b(${escaped})`, 'gi'), '<span class="SearchFieldMulti__highlighted_text">$1</span>');
			};
			const generateLogo = item => config.hasLogo ? `<img loading="lazy" src="/static/v${js_params.version}/images/airlines/iata/small/${item.code}.png" alt="" onerror="this.style.display='none'">` : '';
			// the text is one span so it stays a single flex item, otherwise the highlight blockifies
			const generateLiElement = item => `<li class="list-item SearchFieldMulti__row" data-iata="${item[config.connectApiResponseProperty]}">${generateLogo(item)}<span>${highlightMatch(generateText(item))}</span></li>`;
			const ulHeader = `<li class="list-item-header SearchFieldMulti__section_header SearchFieldMulti__section_header--rounded">${config.headerText}</li>`;
			response.forEach((item) => {
				listHtml += generateLiElement(item);
			});
			if (response.length === 0) {
				listHtml = `<li class="list-item SearchFieldMulti__row">${l('showresult.noMoreResults')}</li>`;
			}
			listElement.innerHTML = ulHeader + listHtml;
			qs('.list-item[data-iata]', listElement)?.classList.add('SearchFieldMulti__row--hovered');
		});
	},
	callEmissionCalc () {
		// Loop over all legs and get data from child elements, then remove any legs without a "from" or "to"
		const allMulti = qsa('.abSearchBox__leg')
			.map((leg, index) => ({
				from: window.searchBox.data.legs[index]?.fromIatas?.[0]?.iata,
				to: window.searchBox.data.legs[index]?.toIatas?.[0]?.iata,
				aircraft: qs('.emission-aircraft-input', leg).getAttribute('data-iata') || '',
				airline: qs('.emission-airline-input', leg).getAttribute('data-iata') || '',
				numPassengers: qs('#passenger-count').innerHTML
			}))
			.filter(leg => (leg.from && leg.to) && (leg.from !== leg.to));

		const isReturn = gebi('flightType').checked;

		if (allMulti.length) {
			ConnectApi('EmissionCalc', 'calculateFlightInfo', [allMulti, isReturn]).then((response) => {
				response = JSON.parse(response);
				this.store.co2 = Math.round(response[0]);
				this.store.co2Price = Math.round(0.150019357 * response[0]);
				gebi('actual-estimate').innerHTML = this.store.co2.toLocaleString('sv') + ' kg CO₂';
				gebi('emission-price').innerHTML = lc(this.store.co2Price);
				gebi('emission-link').href = response[1];
				gebi('emission-link').target = '_blank';
				this.setBiofuelCost();
			});
		} else {
			this.store.co2 = null;
			this.store.co2Price = null;
			const placeholder = '<span class="estimate-placeholder"></span>';
			gebi('actual-estimate').innerHTML = `${placeholder} kg CO₂`;
			gebi('reduce-emissions').innerHTML = `${placeholder} kg CO₂`;
			gebi('emission-price').innerHTML = `${placeholder} kr`;
			gebi('reduce-price').innerHTML = `${placeholder} kr`;
			gebi('emission-link').href = '';
		}
	},
	fixInputTabIndexes () {
		qsa('input').forEach((input, index) => {
			input.tabIndex = index + 1;
		});
	}
};

documentReady(() => {
	carbonCompensate.init();
});

window.carbonCompensate = carbonCompensate;
